import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const place_order = createAsyncThunk(
  "order/place_order",
  async ({
    price,
    products,
    shipping_fee,
    shippingInfo,
    userId,
    navigate,
    items,
    partner_emails,
  }) => {
    try {
      const { data } = await api.post("/home/order/palce-order", {
        price,
        products,
        shipping_fee,
        shippingInfo,
        userId,
        navigate,
        items,
        partner_emails,
      });
      navigate("/payment", {
        state: {
          price: price + shipping_fee,
          items,
          orderId: data.orderId,
        },
      });
      //console.log(data)
      return true;
    } catch (error) {
      console.log(error.response);
    }
  }
);

// New get_sellers_email action to fetch the emails from the backend
export const get_sellers_email = createAsyncThunk(
  "order/get_sellers_email",
  async (sellerIds, { rejectWithValue, fulfillWithValue }) => {
    try {
      // Fetch emails for all sellers in the provided sellerIds array
      const emails = [];
      for (let sellerId of sellerIds) {
        const { data } = await api.get(`/get-seller-email/${sellerId}`);
        emails.push(data.email);
      }
      return fulfillWithValue(emails); // Return the list of emails
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_orders = createAsyncThunk(
  "order/get_orders",
  async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/customer/gat-orders/${customerId}/${status}`
      );
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

export const get_order = createAsyncThunk(
  "order/get_order",
  async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/home/customer/gat-order/${orderId}`);
      return fulfillWithValue(data);
    } catch (error) {
      console.log(error.response);
    }
  }
);

// Upload Document Thunk
export const upload_document = createAsyncThunk(
  "order/upload_document",
  async ({ orderId, documents }, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/order/upload-documents", documents, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error uploading documents"
      );
    }
  }
);

export const getDocuments = createAsyncThunk(
  "order/getDocuments",
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/order/get-documents/${orderId}`);
      return data; // Return documents array
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const orderReducer = createSlice({
  name: "order",
  initialState: {
    myOrders: [],
    errorMessage: "",
    successMessage: "",
    myOrder: {},
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [get_orders.fulfilled]: (state, { payload }) => {
      state.myOrders = payload.orders;
    },
    [get_order.fulfilled]: (state, { payload }) => {
      state.myOrder = payload.order;
    },
    [get_sellers_email.fulfilled]: (state, { payload }) => {
      state.sellerEmails = payload; // Store the fetched seller emails
    },
    [get_sellers_email.rejected]: (state, { payload }) => {
      state.errorMessage = payload.error || "Failed to fetch seller emails";
    },
    [upload_document.fulfilled]: (state, { payload }) => {
      state.documents = payload.documents; // Update documents list in state
    },
    [upload_document.rejected]: (state, { payload }) => {
      state.uploadError = payload.error;
    },
    [getDocuments.fulfilled]: (state, { payload }) => {
      state.documents = payload;
    },
  },
});

export const { messageClear } = orderReducer.actions;
export default orderReducer.reducer;
